module.exports = __webpack_public_path__ + "img/coolwallet-sample.826d1e72.png";